var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"takeClothesIndexView content-index"},[(_vm.activateValue==0)?_c('div',[_c('logisticsInStore')],1):_vm._e(),(_vm.activateValue==1)?_c('div',[_c('oldStores')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }